module.exports = __webpack_public_path__ + "static/Image_Asset_5-1fddafb178bdc543c764bafd738dfec5.png";